import { Effect, Layer } from "effect";
import { kvClipboardFailure } from "./clipboard-model.ts";
import { KVClipboardIo } from "./clipboard-service.ts";

export const KVClipboardIoLive = Layer.succeed(KVClipboardIo, KVClipboardIo.of({
  writeText: text => Effect.tryPromise({
    try: () => navigator.clipboard.writeText(text),
    catch: kvClipboardFailure
  })
}));
